import { Lock } from "lucide-react";
import { Link } from "react-router-dom";

// <Locked/> — shared placeholder for any surface gated by TBAC.
// Charcoal card + bronze accent (matches existing CDI aesthetic).
// Deliberately minimal — no upsell CTAs so Premium stays "Coming Soon".
export default function Locked({
  title = "This feature is locked",
  message = "Upgrade to Basic to unlock this feature.",
  showBasicCta = false,
  testid = "locked-panel",
}) {
  return (
    <div
      data-testid={testid}
      className="my-4 p-6 rounded-md flex flex-col items-center text-center gap-3"
      style={{
        background: "#0f0f0f",
        border: "1px dashed #C9A86A",
        color: "#c9c9c9",
      }}
    >
      <div
        aria-hidden
        style={{
          width: 40, height: 40, borderRadius: 999,
          background: "#231d10",
          border: "1px solid #C9A86A",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#C9A86A",
        }}
      ><Lock size={18} /></div>
      <div className="font-semibold" style={{ color: "#f7f7f7" }} data-testid={`${testid}-title`}>{title}</div>
      <div className="text-xs" style={{ color: "#9a9a9a", maxWidth: 360, lineHeight: 1.6 }} data-testid={`${testid}-message`}>
        {message}
      </div>
      {showBasicCta && (
        <Link
          to="/auth/purchase-plan"
          data-testid={`${testid}-cta`}
          className="text-xs font-semibold mt-2 px-3 py-2 rounded"
          style={{
            background: "#C9A86A",
            color: "#0f0f0f",
            textDecoration: "none",
            letterSpacing: "0.3px",
          }}
        >Upgrade to Basic</Link>
      )}
    </div>
  );
}
